if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        console.log("Modal show triggered");
        console.log("Opener element:", opener);
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        console.log(
          "Active media ID:",
          this.openedBy.getAttribute("data-media-id")
        );

        const galleryImages = this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            "data-media-id"
          )}"])`
        );

        console.log(galleryImages);
        galleryImages.forEach((element) => {
          element.classList.remove("active");
        });

        const mediaThumbnails = this.querySelectorAll(".media-thumbnail");
        mediaThumbnails[0].classList.add("active");

        const mediaPreviews = this.querySelectorAll(".media-slide");
        mediaPreviews[0].classList.add("active");

        // galleryImages[0].classList.add("active");

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );

        console.log(activeMedia, "activeMedia");

        // const activeMediaTemplate = activeMedia.querySelector("template");
        // console.log(activeMediaTemplate, "activeMediaTemplate");
        // const activeMediaContent = activeMediaTemplate
        //   ? activeMediaTemplate.content
        //   : null;
        // activeMedia.classList.add("active");
        // activeMedia.scrollIntoView();

        // const container = this.querySelector('[role="document"]');
        // container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        // if (
        //   activeMedia.nodeName == "DEFERRED-MEDIA" &&
        //   activeMediaContent &&
        //   activeMediaContent.querySelector(".js-youtube")
        // )
        // activeMedia.loadContent();
      }
    }
  );
}
